// Styles
import IframeContainer from "../IframeContainer.styles";
import PowerBIDashboard from "../../../components/Common/PowerBIDashboard";
import React from "react";

type Props = {};

export default function FundMetrics({}: Props) {
    return (
        <IframeContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="2ea7197c-266c-4f93-ac51-a52cc1bdce84"
                    workspaceId="0ab7398c-fff1-4373-b543-e7d6d23657cd"
                ></PowerBIDashboard>
            </div>
        </IframeContainer>
    );
}
